import './receive.scss'
import { useLocal } from '@/i18n/LocalContext'
import CommonModal from '@/components/CommonModal/CommonModal'
import Prop from '@/components/Prop/Prop'

interface ReceiveProps {
  open: boolean
  text?: string
  hideText?: boolean
  propList: RewardViewList
  onClose: () => void
  pending?: boolean
}
export default function Receive(props: ReceiveProps) {
  const { open, propList, onClose, pending } = Object.assign<
    Partial<ReceiveProps>,
    ReceiveProps
  >(
    {
      open: false,
      propList: [],
      pending: false,
    },
    props
  )

  const { $t } = useLocal()

  return (
    <CommonModal
      type="receive"
      open={open}
      title={$t('恭喜获得')}
      onClose={onClose}
    >
      {[
        [
          <div key="0" className="receive-placer"></div>,
          <div key="1" className="receive">
            <ul className="receive-prop-list">
              {pending ? (
                <li className="__onemt__loader-box">
                  <div className="__onemt__loader"></div>
                </li>
              ) : (
                propList.map((reward, i) =>
                  !reward.icon ? null : (
                    <li key={i} className="receive-prop">
                      <Prop
                        name={reward.name}
                        imgSrc={reward.icon}
                        count={reward.count}
                        get={false}
                        desc={reward.desc}
                        key={reward.key}
                        pkey={reward.key}
                      />
                    </li>
                  )
                )
              )}
            </ul>
            {!props.hideText && (
              <p className="common-modal-text">
                {!props.text
                  ? $t(
                      '奖励将通过游戏内邮件发送给您，邮件有效期15天，请您尽快领取！'
                    )
                  : props.text}
              </p>
            )}
          </div>,
        ],
        [
          <a key="21" className="common-modal-btn" onClick={onClose}>
            <span>{$t('确定')}</span>
          </a>,
        ],
      ]}
    </CommonModal>
  )
}
